<template> </template>
<script>
//import LoginLayout from "@/layouts/LoginLayout";
import { LOGOUT } from "@/store/modules/actions.type";
export default {
  created() {
    //console.log("logout 1")
    // this.$emit("update:layout", LoginLayout);
    /* this.$store.dispatch("users/destroyToken").then(response => {
      //console.log("logout 2")
      this.$router.push({ name: "sign-in" });
     // console.log("logout 3")
    });*/
    this.$store.dispatch(LOGOUT).then(() => {
      this.$router.push({ name: "sign-in" });
    });
  }
};
</script>
